import { FC } from 'react';
import Link from 'next/link';
import styles from './Previous.module.scss';

interface IPrevious {
  currentPageNo?: number;
  postName?: string;
}

const Previous: FC<IPrevious> = ({ currentPageNo, postName }) => {
  if (!currentPageNo) {
    return null;
  }

  if (0 === currentPageNo - 1) {
    return null;
  }

  const paginationLink = `/${postName}${currentPageNo - 1}`;

  return (
    <Link prefetch={false} className={styles.prev} href={currentPageNo === 2 ? `/${postName?.split('pages')[0].split(`/${currentPageNo}`)[0].slice(0, -1)}` : paginationLink}>
      <span className={styles.prev__txt}>Предыдущая</span>
    </Link>
  );
};

export default Previous;
